import * as React from 'react';
import styled from '../../theme/styled-components';
import { rem, rgba } from 'polished';
import API from '../../services/API';
import { __ } from '@bart.sk-eshop/react-i18n';
import { withRouter, WithRouterProps } from 'react-router';
import { ErrorAlert, Loader } from '@bart.sk-eshop/eshop-defaults';
import { LogoutButton } from './MyAccount';

const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(420)};
  padding: ${rem(25)};
  background-color: white;
  margin: ${rem(30)} auto 0;
  border-radius: ${rem(4)};
`;

const AuthButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(25)};
`;

const ConfirmButton = styled(LogoutButton)`
  margin: ${rem(16)} 0 0;
  border-radius: ${rem(2)};
`;

const SuccessIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(16)};
`;

const SuccessTitle = styled.h2`
  font-size: ${rem(24)};
  font-weight: 600;
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.color.success};
  text-align: center;
  margin: 0 0 ${rem(24)};
  line-height: ${rem(32)};
`;

const SuccessCheckSvg = styled.svg`
  circle {
    fill: ${({ theme }) => rgba(theme.color.success, 0.12)};
    stroke: ${({ theme }) => theme.color.success};
  }
  path {
    stroke: ${({ theme }) => theme.color.success};
  }
`;

const SuccessCheckIcon: React.FC = () => (
  <SuccessCheckSvg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="32" cy="32" r="30" strokeWidth="2" />
    <path
      d="M20 33 L29 42 L45 24"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SuccessCheckSvg>
);

const InfoText = styled.p`
  font-family: ${({ theme }) => theme.font.secondary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(15)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(24)};
`;

const Title = styled.h1`
  font-size: ${rem(30)};
  font-weight: 400;
  position: relative;
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

interface State {
  error: string;
  confirmed: boolean;
  fetching: boolean;
}

class WithdrawalConfirmation extends React.Component<WithRouterProps, State> {
  constructor(props) {
    super(props);

    this.state = {
      error: '',
      confirmed: false,
      fetching: false,
    };
  }

  public onConfirmClick = async () => {
    try {
      this.setState({ fetching: true });
      await API.confirmWithdrawal({}, { token: this.props.params.token });
      this.setState({ confirmed: true, fetching: false });
    } catch (exp) {
      this.setState({
        error: exp?.details?.description || __('Nastala chyba'),
        fetching: false,
      });
    }
  };

  public onOk = () => {
    this.setState({ confirmed: false, error: '' });
    this.props.router.push('/');
  };

  public render() {
    const { error, fetching, confirmed } = this.state;
    return (
      <Loader loading={fetching}>
        <Wrapper>
          {!confirmed ? (
            <div>
              {error ? <ErrorAlert message={error} /> : ''}
              <Title>{__('Odstúpenie od zmluvy')}</Title>
              <InfoText>
                {__(
                  'Kliknutím na tlačidlo nižšie potvrdíte odstúpenie od zmluvy.',
                )}
              </InfoText>

              <AuthButtonWrapper>
                <ConfirmButton onClick={this.onConfirmClick}>
                  {__('Potvrdiť odstúpenie')}
                </ConfirmButton>
              </AuthButtonWrapper>
            </div>
          ) : (
            <div>
              <SuccessIconWrapper>
                <SuccessCheckIcon />
              </SuccessIconWrapper>
              <SuccessTitle>
                {__('Odstúpenie od zmluvy bolo úspešne potvrdené.')}
              </SuccessTitle>
              <AuthButtonWrapper>
                <ConfirmButton onClick={this.onOk}>
                  {__('Späť na domovskú stránku')}
                </ConfirmButton>
              </AuthButtonWrapper>
            </div>
          )}
        </Wrapper>
      </Loader>
    );
  }
}

export default withRouter(WithdrawalConfirmation);
